<template>
    <div class="willOffer">
        <div class="sectionHeader" v-if="showHeader">
            <div class="isFixed">
                <mainHeader class="mainHeader" @logout="logoutClick"></mainHeader>
            </div>
        </div>
        <!-- <back-to-top transitionName="fade" :customStyle="myBackToTopStyle"  :iconColor="myBackToTopStyleIconColor"
            :visibilityHeight="300" :backPosition="0">
        </back-to-top> -->
        <div class="offer-title ben-size-15 ben-text-bold ben-000-color">我要报价</div>
        <offerInfo :data="wantBuyDetails" @setOfferTopInfo="setOfferTopInfo"></offerInfo>
        <offerContacts :data="wantBuyDetails" @setOfferContacts="setOfferContacts"></offerContacts>
        <offerList :data="wantBuyDetails" @oneEdit="oneEdit" ></offerList>
        <van-popup  v-model="offerAffirmShow" overlayClass="affirmPopup" :close-on-click-overlay=false>
            <offerAffirm :clickOfferDetail="clickOfferDetail" :data="wantBuyDetails" @offerUnitPrice="offerUnitPrice"></offerAffirm>
            <div class="close-popup" @click="offerAffirmShow=false">
                <img src="./../../assets/close.png" alt="" srcset="">
            </div>
        </van-popup>
        <van-popup  v-model="offerAffirmedShow" overlayClass="affirmPopup" :close-on-click-overlay=false @close="clickOfferAffirmed">
            <offerAffirmed :data="wantBuyDetails"></offerAffirmed>
            <div class="close-popup" @click="offerAffirmedShow=false">
                <img src="./../../assets/close.png" alt="" srcset="">
            </div>
        </van-popup>
        <div class="offer-div ben-fff-bg">
            <van-row type="flex">
                <van-col span="15" class="ben-align-right ben-size-12"> 
                    <span class="ben-000-color">总报价:</span>
                    <span class="ben-c41335-color ben-text-bold">￥</span>
                    <span class="ben-c41335-color ben-text-bold ben-size-15">{{utils.num_format(willOfferCountTotail)}}</span>
                </van-col>
                <van-col span="8" offset="1">
                    <button class="ben-btn-r ben-size-15" @click="baojiaClick">发送报价</button>
                </van-col>
            </van-row>
        </div>
        <Login :show="showLogin" @click="loginPopClick"></Login>
    </div>
</template>
<script>
import mainHeader from '@/view/header'
// import backToTop from './components/backToTop'
import offerInfo from "./components/offerInfo.vue"
import offerContacts from "./components/offerContacts.vue"
import offerList from "./components/offerList.vue"
import offerAffirm from "./components/offerAffirm.vue"
import offerAffirmed from "./components/offerAffirmed.vue"
import Login from './../shopping/goods/pop-login.vue'
import { createNamespacedHelpers, mapGetters, mapActions as mapOtherActions, mapState as mapOtherState, } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("procurement");
export default {
    name:'willOffer',
    inject: ['reload'], // 界面刷新

    components: {
        mainHeader,offerInfo,offerContacts,offerList,
        offerAffirm,offerAffirmed,Login
    },
    data () {
        return {
            isLogin :0,
            id :"",
            showLogin : false,
            offerAffirmShow : false,
            offerAffirmedShow : false,
            clickOfferDetail : {},
            baojiaClickLoading : false,
            buyObj : {
                want_buy_id : "",
                offer_name  : "",
                offer_theme : "",
                offer_phone: "",
                offer_qq:"",
                offer_email:"",
                added:"",
                delivery_date: "",
                details : ''
            },
            myBackToTopStyle: {
                'right': '15px',
                'bottom': '70px',
                'width': '40px',
                'height': '40px',
                'border-radius': '20px',
                'line-height': '40px', 
                'background': '#C41335',
                "color" : "#ffffff"
            },
            myBackToTopStyleIconColor : {
                "color" : "#ffffff"
            },
            showHeader : false,
            tabHeight : 0,
        }
    },
    created () {
        this.id = this.$route.query.id;
        if(this.utils.isIphoneOrPc()=='pc'){
            // location.href = "192.168.97:7006/shoplist?id="+this.id
            location.href = "https://www.zxzx119.com/shoplist?id="+this.id

        }
         if (this.$route.query.isApp == 1 || localStorage.getItem('isApp') == 1) {
            this.showHeader = false
            } else {
            this.showHeader = true
            }
            if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1 || parseInt(this.$route.query.isApp) === 2 || parseInt(localStorage.getItem('isApp')) === 2) {
            var _this = this
            window['androidTabHeight'] = (result) => {
                _this.androidTabHeight(result)
            }
            if (this.utils.isIphone() === true) {
                this.androidTabHeight('0')
            } else {
                this.androidTabHeight(window.zxzx.getNavigationBarHeight())
            }
            }
    },
    computed:{
        ...mapState(['wantBuyDetails',"willOfferCountTotail"]),
    },
    methods: {
        ...mapActions(["getWantBuyDetails","wantOfferAddOffer","wantOfferSubmit","wantOfferClean"]),
        androidTabHeight (value) {
        // 设置android 模态导航条
        if (this.utils.isIphone() === true) {
            if (this.utils.isIphoneX() === true) {
            this.tabHeight = 20
            } else {
            this.tabHeight = 0
            }
        } else {
            this.tabHeight = parseInt(value)
        }
        },
        clickOfferAffirmed(){
            this.$router.push({
                path: 'offerDetail',
                query : {
                    id : this.id
                }
            })
        },
        setOfferTopInfo(obj){
            this.buyObj.added = obj.added;
            this.buyObj.delivery_date = obj.delivery_date
        },
        setOfferContacts(obj){
            this.buyObj.offer_email = obj.offer_email;
            this.buyObj.offer_name = obj.offer_name
            this.buyObj.offer_phone = obj.offer_phone
            this.buyObj.offer_qq  = obj.offer_qq
        },
        getLoading(num){//1 为首次加载 
            let that = this
            that.getWantBuyDetails({id:that.id}).then(res=>{
                if(res.code==0&&res.success){
                    if(num!=1){
                        return false
                    }
                    if(res.data.isOffered==1){
                        return false
                    }
                    let offerList = res.data.wantBuyAndDetails.details;
                    let isOffered = false;
                    for(let i=0;i<offerList.length;i++){
                        let com = offerList[i]
                        if(com.tails.wantOfferDetail){
                            isOffered = true
                        }
                    }
                   if(isOffered){
                       that.$dialog.confirm({
                        // title: '标题',
                        message: '您有未完成的报价是否继续?',
                        confirmButtonText :'继续',
                        cancelButtonText : '新建',
                        beforeClose,
                    });
                   }
                   function beforeClose(action, done) {
                        if (action === 'cancel') {
                            // setTimeout(done, 1000);
                            that.wantOfferClean({want_buy_id:that.id}).then(res=>{
                                that.getLoading(2)
                                setTimeout(done, 1000);
                            })
                        } else {
                            done();
                        }
                    }
                }
            })
        },
        offerUnitPrice(data){//单个提交报价
            let yData = this.clickOfferDetail
            let resData = {
                buy_num : yData.buy_num,
                goods_describe : yData.goods_describe,
                goods_name : yData.goods_name,
                unit : yData.unit,
                want_buy_detail_id : yData.id,
                detail_added : JSON.parse(data).detail_added,
                offer_unit_price : JSON.parse(data).offer_unit_price * 100,
            }
            this.wantOfferAddOffer(resData).then(res=>{
                if(res.code==1){
                    // this.Toast(res.message)
                }else{
                    this.getLoading(2)
                    this.offerAffirmShow = false
                }
               
            })

        },
        oneEdit(com){
            console.log(this.utils.loginState())
            if (this.utils.loginState() == 0) {
                this.showLogin = true
                return
            }
            this.clickOfferDetail = com
            this.offerAffirmShow = true;

        },
        logoutClick: function () { // 退出登录  刷新界面
            this.reload()
        },
        
        baojiaClick(){
            console.log(this.baojiaClickLoading)
            if(this.utils.loginState()==0){
                this.Toast("请先登录")
                return
            }
            if(this.baojiaClickLoading){
                return
            }
            this.baojiaClickLoading = true
            this.buyObj.want_buy_id = this.wantBuyDetails.wantBuyAndDetails.id;
            this.buyObj.details = this.wantBuyDetails.wantBuyAndDetails.details;
            this.buyObj.offer_theme = `我对您发布的" ${this.wantBuyDetails.wantBuyAndDetails.title} "很感兴趣`
            if(this.buyObj.delivery_date===""){
                this.Toast("请输入可交货到指定地点天数")
                this.baojiaClickLoading = false
                return
            }
            if(this.buyObj.offer_name===""){
                this.Toast("请输入联系人")
                this.baojiaClickLoading = false
                return
            }
            if(this.buyObj.offer_phone===""){
                this.Toast("请输入联系电话")
                this.baojiaClickLoading = false
                return
            }
            if(!this.utils.isPhone(this.buyObj.offer_phone)){
                this.Toast("请输入正确的联系电话")
                this.baojiaClickLoading = false
                return
            }
            if(this.buyObj.offer_email!==""&& !this.utils.isEmail(this.buyObj.offer_email)){
                this.Toast("请输入正确的邮箱")
                this.baojiaClickLoading = false
                return
            }
            
            this.wantOfferSubmit(this.buyObj).then(res=>{
                this.baojiaClickLoading = false
                if(res.code==0&&res.success){
                    this.offerAffirmedShow = true
                }
                // else{
                //     this.Toast(res.message)
                // }
            }).catch(err=>{
                this.baojiaClickLoading = false
            })
        },
        checkLogin () {
          this.utils.get(this.companyUrl + '/ent/json', null, res => {
                localStorage.setItem('userinfo', JSON.stringify(res.data))
            })
        },
        loginPopClick: function (type) { // 0 隐藏 1 登录成功 2 注册 3 忘记密码
            this.showLogin = false
            if (type === 1) {
                this.isLogin = 1
            }
            if (type === 2) {
                this.$router.push({ path: 'register' })
            }
            if (type === 3) {
                this.$router.push({ path: 'retrieve' })
            }
        },
    },
    mounted () {
        this.getLoading(1)
        var _this = this
        this.utils.isUserLogin(function (login) {
        if (login === 0) {
            _this.isLogin = 0
        } else {
            _this.isLogin = 1
            _this.checkLogin()
        }
        })
    },
}

</script>


<style lang='scss' scoped>
.willOffer{
    background: #eee;
    margin-bottom: 75px;
    .van-popup{
        overflow-y: initial;
        top: 35%;
    }
    .close-popup{
        position:absolute;
        bottom: -60px;
        left: 50%;
        -webkit-transform: translate3d(-50%,-0%,0);
        transform: translate3d(-50%,-0%,0);
        img{
            width: 30px;
            height: 30px;
        }
    }
    .offer-div{
        height: 75px;
        line-height: 75px;
        position: fixed;
        width: 100%;
        bottom: 0;

        
    }
    .offer-title{
        height: 50px;
        line-height: 50px;
        padding: 0 15px;
        background: #fff;
    }
}
</style>


// WEBPACK FOOTER //
// src/view/procurement/willOffer.vue